import React from 'react';
import { CheckIcon } from 'lucide-react';
import { VC_CAPABILITIES, VC_EXTRA_CAPABILITIES, type VcCapability } from '../../data/ventureContent';
import { PRODUCT_SCREENSHOTS } from '../../data/dgpt';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { StepImage } from '../dgpt/product/StepImage';
import { DealRadarPreview } from './DealRadarPreview';
import { cn } from '../../src/lib/utils';
function Visual({
  kind
}: {
  kind: VcCapability['visual'];
}) {
  if (kind === 'radar') return <DealRadarPreview data-id="element-1311" data-mp="1vmq97zz21bma" />;
  return <StepImage image={PRODUCT_SCREENSHOTS[kind]} data-id="element-1312" data-mp="1vlyip3kbe42v" />;
}
export function VcCapabilities() {
  return <section aria-labelledby="vc-capabilities-heading" className="border-b border-hairline-soft bg-ink" data-id="element-1313" data-mp="20guhqnnyxrph">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-20 sm:px-6 lg:px-8 lg:py-28" data-id="element-1314" data-mp="25fnm9qla28di">
        <SectionHeading eyebrow="In the product" headingId="vc-capabilities-heading" title="Thesis fit, Deal Radar, structured diligence and IC — in one place." data-id="element-1315" data-mp="29dd23bi4w7ag" />

        <div className="mt-16 flex flex-col gap-20 lg:gap-28" data-id="element-1316" data-mp="r4igaaqze16r">
          {VC_CAPABILITIES.map((capability, index) => <article key={capability.id} id={capability.id} aria-labelledby={`${capability.id}-title`} className="grid scroll-mt-24 gap-10 lg:grid-cols-2 lg:items-center lg:gap-16" data-id="element-1317" data-mp="i5wzol52kw8m" data-mpi={index}>
              <Reveal className={cn(index % 2 === 1 && 'lg:order-2')} data-id="element-1318" data-mp="1aub2de73sgqi">
                <p className="text-[11px] font-semibold uppercase tracking-[0.1em] text-lime" data-id="element-1319" data-mp="15wsorai55dc6">{capability.eyebrow}</p>
                <h3 id={`${capability.id}-title`} className="sf-display mt-3 text-balance text-[26px] leading-[1.1] text-text-primary sm:text-[34px]" data-id="element-1320" data-mp="113q27mbs745h">
                  {capability.title}
                </h3>
                <p className="mt-4 text-[15px] leading-relaxed text-text-secondary sm:text-base" data-id="element-1321" data-mp="1tmwupoisxp6c">{capability.body}</p>
                <ul className="mt-6 flex flex-col gap-2.5" data-id="element-1322" data-mp="1osivfb10qxwe">
                  {capability.points.map(point => <li key={point} className="flex items-start gap-2.5 text-[15px] text-text-primary" data-id="element-1323" data-mp="3n41cte53ohor">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-violet-soft text-lime" data-id="element-1324" data-mp="39cwa236fr9a7">
                        <CheckIcon className="h-3 w-3" strokeWidth={2.5} aria-hidden="true" data-id="element-1325" data-mp="3eag0e1gercii" />
                      </span>
                      {point}
                    </li>)}
                </ul>
              </Reveal>
              <Reveal delay={0.06} className={cn('min-w-0', index % 2 === 1 && 'lg:order-1')} data-id="element-1326" data-mp="34bgrqivn7gvi">
                <Visual kind={capability.visual} data-id="element-1327" data-mp="2qfv68lombf7u" />
              </Reveal>
            </article>)}
        </div>

        <ul className="mt-20 grid gap-4 md:grid-cols-3" data-id="element-1328" data-mp="omfaxbhl5c6j">
          {VC_EXTRA_CAPABILITIES.map((item, index) => <Reveal key={item.title} as="li" delay={index * 0.04} className="rounded-2xl border border-hairline bg-surface p-6" data-id="element-1329" data-mp="tm1ojm1bsufv" data-mpi={index}>
              <h3 className="text-base font-semibold text-text-primary" data-id="element-1330" data-mp="13q8f6u1l48f1">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-text-secondary" data-id="element-1331" data-mp="yrex0obcrt8j">{item.body}</p>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}